// extracted by mini-css-extract-plugin
export default {"pastDue35":"reports_pastDue35__XJn1H","tbody":"reports_tbody__dx9p8","pastDue25":"reports_pastDue25__DB8pV","pastDue15":"reports_pastDue15__Libcd"};